import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { GET_PARTNERS_PROPOSALS } from 'modules/aftermarketPartner/api';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { ProposalsTable } from '../../tables';
import { ProposalsTableDataResponse, ProposalsTableDataVariables } from '../../../api/types';

export const ProposalsPage = () => {
  const account = useSelector((state: any) => state.account);

  const [dynamicKey, setDynamicKey] = useState<number>(Math.random());

  const { data, loading } = useQuery<ProposalsTableDataResponse, ProposalsTableDataVariables>(GET_PARTNERS_PROPOSALS, {
    skip: !account.id,
    variables: { accountId: account.id },
  });

  return (
    <CardContainer
      title="Proposals"
      actionBtnProps={{
        variant: 'contained',
        label: 'Reset Filters',
        onClick: () => setDynamicKey(Math.random()),
      }}
    >
      <ProposalsTable
        key={dynamicKey}
        loading={loading}
        routePath="proposals"
        tableData={(data?.partnersProposals as any) ?? []}
      />
    </CardContainer>
  );
};
